<template>
  <div class="instructions-panel">
    <TheTeamInstructionsDefensiveShape class="defensive-shape" />
    
    <div>
      <SelectTeamInstruction
        name="pressing-urgency"
        :value="pressingUrgency"
        mutation="updatePressingUrgency"
        :options="options.pressingUrgency"
      >
        {{ $t('tactics.instructions.outOfPossession.triggerPress') }}
      </SelectTeamInstruction>

      <CheckboxTeamInstruction
        name="prevent-gk-distribution"
        :value="preventGKDistribution"
        mutation="updatePreventGKDistribution"
      >
        {{ $t('tactics.instructions.outOfPossession.markingAndTackling.preventShortGKDistribution') }}
      </CheckboxTeamInstruction>

      <SelectTeamInstruction
        name="tackling"
        :value="tackling"
        mutation="updateTackling"
        :options="options.tackling"
      >
        {{ $t('tactics.instructions.outOfPossession.markingAndTackling.tackling.tackling') }}
      </SelectTeamInstruction>

      <SelectTeamInstruction
        name="stepping-up"
        :value="steppingUp"
        mutation="updateOffsideTrap"
        :options="options.steppingUp"
      >
        {{ $t('tactics.instructions.outOfPossession.defensiveShape.defensiveLine.defensiveLine') }}
      </SelectTeamInstruction>

      <SelectTeamInstruction
        name="pressing-trap"
        :value="pressingTrap"
        mutation="updatePressingTrap"
        :options="options.pressingTrap"
      >
        {{ $t('tactics.instructions.outOfPossession.pressingTrap') }}
      </SelectTeamInstruction>

      <SelectTeamInstruction
        name="cross-engagement"
        :value="crossEngagement"
        mutation="updateCrossEngagement"
        :options="options.crossEngagement"
      >
        {{ $t('tactics.instructions.outOfPossession.crossEngagement') }}
      </SelectTeamInstruction>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CheckboxTeamInstruction from "@/components/CheckboxTeamInstruction";
import TheTeamInstructionsDefensiveShape from "@/components/TheTeamInstructionsDefensiveShape";
import SelectTeamInstruction from "@/components/SelectTeamInstruction";

export default {
  components: {
    CheckboxTeamInstruction,
    TheTeamInstructionsDefensiveShape,
    SelectTeamInstruction
  },

  data: () => {
    return {
      options: {
        pressingUrgency: [
          {value: -2, label: "tactics.instructions.outOfPossession.markingAndTackling.pressing.muchLess"},
          {value: -1, label: "tactics.instructions.outOfPossession.markingAndTackling.pressing.less"},
          {value: 0, label: "tactics.instructions.outOfPossession.markingAndTackling.pressing.standard"},
          {value: 1, label: "tactics.instructions.outOfPossession.markingAndTackling.pressing.more"},
          {value: 2, label: "tactics.instructions.outOfPossession.markingAndTackling.pressing.muchMore"}
        ],
        tackling: [
          {value: 1, label: "tactics.instructions.outOfPossession.markingAndTackling.tackling.getStuckIn"},
          {value: 0, label: ""},
          {value: -1, label: "tactics.instructions.outOfPossession.markingAndTackling.tackling.stayOnFeet"}
        ],
        steppingUp: [
          {value: 1, label: "tactics.instructions.outOfPossession.steppingUp.stepUpMore"},
          {value: 0, label: ""},
          {value: -1, label: "tactics.instructions.outOfPossession.steppingUp.dropOffMore"}
        ],
        pressingTrap: [
          {value: 1, label: "tactics.instructions.outOfPossession.pressingTrap.inside"},
          {value: 0, label: ""},
          {value: -1, label: "tactics.instructions.outOfPossession.pressingTrap.outside"}
        ],
        crossEngagement: [
          {value: 1, label: "tactics.instructions.outOfPossession.crossEngagement.stop"},
          {value: 0, label: ""},
          {value: -1, label: "tactics.instructions.outOfPossession.crossEngagement.invite"}
        ],
      }
    };
  },

  computed: mapState({
    steppingUp: state => state.instructions.outOfPossession.defensiveShape.useOffsideTrap,
    tighterMarking: state => state.instructions.outOfPossession.markingAndTackling.useTighterMarking,
    pressingUrgency: state => state.instructions.outOfPossession.markingAndTackling.pressingUrgency,
    preventGKDistribution: state => state.instructions.outOfPossession.markingAndTackling.preventGKDistribution,
    tackling: state => state.instructions.outOfPossession.markingAndTackling.tackling,
    pressingTrap: state => state.instructions.outOfPossession.pressingTrap,
    crossEngagement: state => state.instructions.outOfPossession.crossEngagement,
  })
}
</script>

<style scoped>
.defensive-shape {
  grid-column: 1 / 3;
}
</style>
